import Constants from "../../rz-status_constants";
import { IMaintanance, Maintanance, FileType } from "../../rz-status_models";
import SearchEngine from "../../rz-status_search";
import Parser from "../../rz-status_parser";
import Loader from "../../rz-status_loader";
import { useState, useEffect } from 'react';
import SearchField from "./SearchField";
import DateFilter from "./DateFilter";
import { useTimer } from "../contextProviders/TimerContext";
import { useCollapse } from "../contextProviders/CollapseContext";
import EventCounter from "./eventCounter";
import useData from "../useData";

export default function()  {
    const { expanded, toggle} = useCollapse();
    const tick = useTimer();


    function isSameDate(date1: Date, date2: Date) {
        return date1.getFullYear() == date2.getFullYear()
            && date1.getMonth() == date2.getMonth()
            && date1.getDate() == date2.getDate();
    }

    const pad = (num, size) => num.toString().padStart(size, "0");

    function createMaintananceDuplicate(maintanance : IMaintanance, date :Date) : IMaintanance {
        var duplicate = structuredClone(maintanance)

        if (!isSameDate(duplicate.startDate, date)) {
            duplicate.startDate = moment(date).hour(0).minute(0).toDate();
        }

        if (!isSameDate(duplicate.endDate, date)) {
            duplicate.endDate = moment(date).hour(23).minute(59).toDate();
        }

        return duplicate;
    }

    function duplicateLongmaintenances(maintenances: IMaintanance[]): IMaintanance[] {
        var result: IMaintanance[] = new Array<IMaintanance>();

        for (var i = 0; i < maintenances.length; i++) {
            var maintanance = maintenances[i];
            var pointer = new Date(maintanance.startDate.toDateString());
            
            if(moment(maintanance.startDate).isBefore(maintanance.endDate)) {
                while (!isSameDate(pointer, maintanance.endDate)) {
                    
                    result.push(createMaintananceDuplicate(maintanance, pointer));
                    pointer.setDate(pointer.getDate() + 1);
                }
            }

            // Letzter Tag
            result.push(createMaintananceDuplicate(maintanance, pointer));
        }

        return result;
    }

    function groupmaintenancesByDate(maintenances: IMaintanance[]): { [day: string]: IMaintanance[]; } {

        var maintenancesByDate: { [day: string]: IMaintanance[]; } = {};
        
        for (var i = 0; i < maintenances.length; i++) {
            var maintanance = maintenances[i];
            var key = pad(maintanance.startDate.getFullYear(), 4) + pad(maintanance.startDate.getMonth() + 1, 2) + pad(maintanance.startDate.getDate(), 2);
            if (maintenancesByDate[key] == null) {
                maintenancesByDate[key] = new Array<IMaintanance>();
            }

            maintenancesByDate[key][maintenancesByDate[key].length] = maintanance;
        }

        return maintenancesByDate;
    }

	const [plannedMaintenanceSearch, setPlannedMaintenanceSearch] = useState(new SearchEngine(["Description", "startDate","endDate", "AffectedSlas"]));

    const [maintenancesByDate, setMaintenancesByDate] = useState([]);
    const [days, setDays] = useState([]);

    const [dateFilter, setDateFilter] = useState(() => m => m);

	const parser = new Parser();
	const loader = new Loader();

    // TODO: unavailabilitly
    const { data, error, loading } = useData(Constants.Paths.maintananceJsonPath, (file) => parser.parseMaintanances(file), [tick]);
	useEffect(() => {
		if (!data) return;
        plannedMaintenanceSearch.setData(data)
        plannedMaintenanceSearch.search("");
        applyFilterAndSetData()
	}, [data])


    function applyFilterAndSetData() {
        var m = dateFilter(plannedMaintenanceSearch.getResults())
        var maintenancesByDate = groupmaintenancesByDate(duplicateLongmaintenances(m));
        setMaintenancesByDate(maintenancesByDate);
        var days = new Array<string>();

        for (var key in maintenancesByDate) {
            days.push(key);
        }
            
        setDays(days.sort());
    }

    return <article className={"plannedMaintenance collapsible"+ ((expanded == 2) ? " open" : "")} id="plannedMaintenance">
        <header>
            <h2>
                <button className="incidentTitle" aria-expanded={(expanded == 2) ? "true" : "false"} aria-controls="generated_content_planned_maintenances" onClick={() => toggle(2)} aria-label={`Geplante Wartungsarbeiten ${(expanded == 2) ? "schließen" : "öffnen"}`}>
                    <span className="h2" id="plannedMaintainanceTitle">Geplante Wartungsarbeiten</span>
                    <div>
                        <EventCounter id="plannedMaintainanceNumber" countable={data}/>
                        <span className="arrow"></span>
                    </div>
                </button>
            </h2>
        </header>
		<div id="generated_content_planned_maintenances" className="collapsible-content">
            { error || data == null
            ? <section className="details clearfix"><div><p>Daten aktuell nicht abrufbar</p></div></section>
            : <>
                <section className="searchAndFilter clearfix">
                    <search aria-label="Geplante Wartungsarbeiten durchsuchen">	
                        <form autoComplete="off">
                            <SearchField onFilterChange={e => {plannedMaintenanceSearch.setSearchTerm(e); plannedMaintenanceSearch.search(); applyFilterAndSetData()}}></SearchField>
                        </form>
                        <DateFilter data={data} onFilterChange={e => {
                            setDateFilter(e);
                            applyFilterAndSetData();
                        }}/>
                    </search>				
                </section>
                <section>
                    {days == null || days.length == 0 
                        ? <div><p>Es sind keine Wartungen geplant.</p></div>
                        : <>
                            <table className="incidents" aria-labelledby="plannedMaintainanceTitle">
                                <thead>
                                    <tr>
                                        <th className="time">Zeit</th>
                                        <th className="taskForDay">Folgende Anwendungen stehen nicht zur Verfügung</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {days.map((day, i) => <Day key={day} maintenances={maintenancesByDate[day]}/>)}
                                </tbody>
                            </table>
                        </>
                    }
                </section>
            </>}
        </div>
    </article>
}

function Day({maintenances}: {maintenances: IMaintanance[]}) {
    const thisDaymaintenances = maintenances.sort(sortmaintenances);
    const day = thisDaymaintenances[0].startDate

    const dateFormat = (date: Date, format: string) => moment(date).local(true).format(format);

    function sortmaintenances(m1: IMaintanance, m2: IMaintanance) {
        if (m1 == null || m1.startDate == null) {
            return -1;
        }

        if (m2 == null || m2.startDate == null) {
            return 1;
        }

        return m1.startDate.valueOf() - m2.startDate.valueOf();
    }

    return thisDaymaintenances.map((maintenance, i) => <tr className="day clearfix" key={maintenance.ticketId} >
            {i == 0 && <th className="time" rowSpan={thisDaymaintenances.length}>{Constants.DateFormat.daynames[parseInt(dateFormat(day, "e"))] + ", " + dateFormat(day, "DD.MM.YYYY")}</th>}

            <td className="tasksForDay">
                <section>{dateFormat(maintenance.startDate, "HH:mm") + ' - ' + dateFormat(maintenance.endDate, "HH:mm")}</section>
                <section>
                    <ul data-maintananceid={maintenance.ticketId + "_" + day.getTime() + "_planned"}>
                        {maintenance.affectedServicesInfo.map((service, i) => <li key={i}>{service.name}</li>)}
                    </ul>
                </section>
                {maintenance.descriptionLong && 
                    <section>
                        <p style=>{maintenance.descriptionLong}</p>
                    </section>
                }
            </td>
                </tr>

        )
    }